module.exports = __webpack_public_path__ + "static/media/Notification.8ceb5d10.svg";